import { CurrencyId_Schema } from "@/services/currencies/currenciesSchema";
import { LanguageId_Schema } from "@/services/translation";
import { Nickname_Schema } from "@/services/user/profile/profileSchema";
import { UserFlag_Schema } from "@/services/user/settings/flags/flagsSchema";
import { UserStanding_Schema } from "@/services/user/userSchema";
import { DateTimeIso8601Local_Schema, WholeNumber_Schema } from "@/utilities/schema";
import { z } from "zod";

export const UserSettings_Schema = z
  .object({
    nicknameDaysTillNew: WholeNumber_Schema,

    // Should be Set<UserFlag>. Right now - we just hope array items are unique.
    // Actually there is a validator to make sure inside API fetch methods.
    flags: UserFlag_Schema.array(),

    displayCurrencyId: CurrencyId_Schema,
    displayLanguageId: LanguageId_Schema,
    nickname: Nickname_Schema,
    publicFullName: z.string(),
    publicEmail: z.string(),
    publicPhone: z.string(),
    publicUrlFacebook: z.string(),
    publicUrlInstagram: z.string(),
    publicUrlTikTok: z.string(),
    publicUrlPinterest: z.string(),
    publicUrlWeb: z.string(),
    publicBioDescription: z.string(),
    isChatEmailNotificationEnabled: z.boolean(),
    standing: UserStanding_Schema.nullable().optional(),
    holidayUntil: DateTimeIso8601Local_Schema.nullable(),
  })
  .meta({
    openapi: "CollectorResponse",
  })
  .transform(({ holidayUntil, ...rest }) => ({
    ...rest,
    absenceUntil: holidayUntil ?? null,
  }));
